import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useFeedData() {
  const [sources, setSources] = useState([]);
  const [entries, setEntries] = useState([]);
  const [loadingFeed, setLoadingFeed] = useState(true);
  const [loadingSources, setLoadingSources] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const fetchSources = useCallback(async () => {
    try {
      setLoadingSources(true);
      const { data } = await axios.get(`${API}/sources`);
      setSources(data);
    } catch {
      // silently fail — feed will show empty
    } finally {
      setLoadingSources(false);
    }
  }, []);

  const fetchFeed = useCallback(async () => {
    try {
      setLoadingFeed(true);
      const { data } = await axios.get(`${API}/feed`);
      setEntries(data);
    } catch {
      // silently fail
    } finally {
      setLoadingFeed(false);
    }
  }, []);

  useEffect(() => {
    fetchSources();
    fetchFeed();
  }, [fetchSources, fetchFeed]);

  const addSource = async (url, title, sourceType) => {
    const { data } = await axios.post(`${API}/sources`, { url, title, source_type: sourceType });
    setSources((prev) => [...prev, data]);
    await fetchFeed();
    return data;
  };

  const deleteSource = async (sourceId) => {
    await axios.delete(`${API}/sources/${sourceId}`);
    setSources((prev) => prev.filter((s) => s.id !== sourceId));
    setEntries((prev) => prev.filter((e) => e.source_id !== sourceId));
  };

  const refreshFeeds = async () => {
    setRefreshing(true);
    try {
      await axios.post(`${API}/feed/refresh`, {});
      await fetchFeed();
    } catch {
      // silently fail
    } finally {
      setRefreshing(false);
    }
  };

  return {
    sources,
    entries,
    loadingFeed,
    loadingSources,
    refreshing,
    addSource,
    deleteSource,
    refreshFeeds,
  };
}
